module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_storniert.9b96d1f1.jpg";